<template>
  <div class="enter-address">
    <div class="ly-card search-content">
      <div class="btn-group">
        <el-button size="medium" @click="exportExcel">导出</el-button>
        <advanced-query @search="search" />
      </div>
      <div class="search-group">
        <el-input
          placeholder="班级名称/代码/预约号/学员姓名/身份证号"
          v-model.trim="searchFormData.query"
          @keydown.native.enter="() => search()"
        />
        <el-button type="primary" size="medium" @click="() => search()">查询</el-button>
      </div>
    </div>
    <div class="ly-card">
      <el-tabs v-model="is_add" @tab-click="() => search()">
<!--        <el-tab-pane label="全部" name="-1"></el-tab-pane>-->
        <el-tab-pane label="已添加" name="true"></el-tab-pane>
<!--        <el-tab-pane label="未添加" name="false"></el-tab-pane>-->
      </el-tabs>
      <ly-table
        :tableConfig="tableConfig"
        :getTableData="getTableData"
        :tableHeader="tableHeader"
        :searchFormData="searchFormData"
        class="diy-table"
        ref="lyTable"
      >
        <template v-slot:class_name="row">
          <el-button @click="showClass(row)" type="text" size="mini">{{ row.class_name }}</el-button>
        </template>
        <template v-slot:org_full_name="row">{{
          row.org_full_name && row.org_full_name.replace(/中国儿童中心\/+/, '')
        }}</template>
        <template v-slot:reservation_number="row">
          <el-button type="text" class="reservation-number" size="small" @click="() => openInf(row)">{{
            row.reservation_number
          }}</el-button>
        </template>
        <template v-slot:mail_status="row">
          <el-button v-if="!row.mail_status" @click="finish(row)" type="text" size="mini">邮寄</el-button>
          <span v-else>已邮寄</span>
        </template>
        <template v-slot:action="row">
          <el-button @click="editRow(row)" type="text" size="mini">编辑</el-button>
        </template>
      </ly-table>
    </div>
    <el-dialog title="课程表" :visible.sync="dialogVisibleSc" width="1400px">
      <class-schedule :class_mode="scTime.class_mode" :class_id="scTime.class_id" />
    </el-dialog>
    <el-dialog title="班级信息" :visible.sync="dialogVisibleDetail" width="1000px">
      <class-inf-detail-list
        :isFetch="true"
        @showSc="showSc"
        :defaultFormItemClass="defaultFormItemClass"
      ></class-inf-detail-list>
    </el-dialog>
    <el-dialog title="编辑地址" :visible.sync="isEdit" width="500px">
      <ly-form
        :formConfig="formConfig"
        :formKeys="formKeys"
        :defaultFormItem="defaultFormItemClass"
        ref="lyForm"
      ></ly-form>
      <div slot="footer">
        <el-button size="medium" @click="isEdit = false">取消</el-button>
        <el-button type="primary" size="medium" @click="saveForm">保存</el-button>
      </div>
    </el-dialog>
    <pay-detail
      ref="payDetail"
      :sign_up_id="curItem.sign_up_id"
      :def="curItem"
      :class_id="curItem.class_id"
      :contact_id="curItem.contact_id"
      :buttons="[]"
      @success="search"
    />
  </div>
</template>
<script>
import { Dialog, Input, Tabs, TabPane } from 'element-ui';

import LyTable from '@/components/LyTable';
import { addressTable } from '@/utils/tableHeaderClass';
import { classApi } from '@/api';
import ClassInfDetailList from '@/components/ClassInfDetail/list';
import ClassSchedule from '@/components/ClassSchedule';
import LyForm from '@/components/LyForm';
import AdvancedQuery from '@/components/AdvancedQuery';
import PayDetail from '@/components/PayDetail';
import pattern from '@/utils/pattern';
import utils from '@/utils/utils';

export default {
  name: 'EnteredInterview',
  components: {
    ElDialog: Dialog,
    ElInput: Input,
    LyTable,
    ClassInfDetailList,
    ClassSchedule,
    AdvancedQuery,
    ElTabs: Tabs,
    ElTabPane: TabPane,
    PayDetail,
    LyForm
  },
  data() {
    return {
      searchFormData: {
        query: ''
      },
      is_add: '-1',
      tableHeader: addressTable,
      getTableData: classApi.address,
      tableConfig: {
        action: {
          'selection-change': selection => {
            this.selection = selection;
          }
        }
      },
      curItem: {
        class_id: 0,
        contact_id: 0,
        sign_up_id: 0
      },
      dialogVisible: false,
      dialogVisibleSc: false,
      dialogVisibleDetail: false,
      scTime: {},
      defaultFormItemClass: {},
      isEdit: false,
      formKeys: {
        mail_address: {
          type: 'text',
          label: '邮寄地址',
          placeholder: '请填写邮寄地址',
          rules: [
            {
              required: true,
              message: '请填写邮寄地址',
              trigger: 'blur'
            }
          ],
          options: {
            type: 'textarea',
            rows: 3
          }
        },
        receive_contact: {
          type: 'text',
          label: '联 系 人',
          placeholder: '请填写联系人',
          rules: [
            {
              required: true,
              message: '请填写联系人',
              trigger: 'blur'
            }
          ]
        },
        receive_contact_phone: {
          type: 'text',
          label: '联系电话',
          placeholder: '请填写联系电话',
          rules: [
            {
              required: true,
              message: '请填写正确的电话',
              pattern: pattern.mobile,
              trigger: 'blur'
            }
          ]
        }
      },
      formConfig: {
        'label-width': '100px',
        'label-position': 'left',
        ref: 'ly-form',
        inline: false
      }
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    handleTabsClick() {
      this.search();
    },
    search(data) {
      this.isEdit = false;
      this.searchFormData = { ...this.searchFormData, is_add: this.is_add, ...data };
      this.$refs.lyTable.setData();
    },
    showSc(row) {
      this.dialogVisibleSc = true;
      this.scTime = {
        class_mode: row.class_mode,
        class_id: row.id
      };
    },
    showClass(row) {
      this.defaultFormItemClass = { id: row.class_id };
      this.dialogVisibleDetail = true;
    },
    editRow(row) {
      this.isEdit = true;
      this.defaultFormItemClass = { ...row };
    },
    openInf(row) {
      this.curItem = { ...row };
      this.$refs.payDetail.open();
    },
    async saveForm() {
      const { data, valid } = await this.$refs.lyForm.getFormData();
      if (valid) {
        classApi
          .updateMailInfo({
            id: this.defaultFormItemClass.id,
            params: data
          })
          .then(res => {
            if (res && res.data) {
              this.isEdit = false;
              this.search();
            }
          });
      }
    },
    finish(row) {
      classApi
        .batchUpdateMail({
          params: {
            mail_info_ids: [row.id],
            mail_status: true
          }
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '邮寄成功！');
            this.search();
          }
        });
    },
    exportExcel() {
      classApi.exportMailInfo({ params: this.searchFormData }).then(data => {
        if (data) utils.downloadData(data, '邮寄地址');
      });
    }
  }
};
</script>
<style lang="less">
.enter-address {
  .search-content {
    display: flex;
    justify-content: space-between;
    .search-group .el-input {
      width: 285px;
      margin-right: 20px;
    }
  }
}
</style>
